import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './school.reducer';

export const selectSchoolState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectSchoolState, (state: State) => state.error);

export const getLoaded = createSelector(selectSchoolState, (state: State) => state.loaded);

export const getAll = createSelector(selectSchoolState, selectAll);

export const getCount = createSelector(selectSchoolState, selectTotal);

export const getIds = createSelector(selectSchoolState, selectIds);

export const getAllEntities = createSelector(selectSchoolState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * schools$: schoolInterface[] = this.store.pipe(
    select(schoolQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectSchoolState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * schools$: schoolInterface = this.store.pipe(
    select(schoolQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectSchoolState,
  (state: State, props: { id: number }) => state.entities[props.id]
);
